export enum HeatPumpOperatingMode {
    Monovalent = 'MONOVALENT',
    Alternate = 'ALTERNATE',
    Parallel = 'PARALLEL'
}
